import * as type from '../../../actions/index.types';

const initialState = {
  loading: false,
  detailsLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  assignLoading: false,
  catalogLoading: false,
  rolesData: null,
  roleDetails: null,
  permissionCatalog: null,        // flat list (paginated)
  permissionCatalogGrouped: null, // module → resources tree
  error: null,
};

export function SocietyRoleReducer(state = initialState, action) {
  switch (action.type) {
    case type.GET_SOCIETY_ROLES:
      return { ...state, loading: true, error: null };
    case type.GET_SOCIETY_ROLES_SUCCESS:
      return { ...state, loading: false, rolesData: action.payload?.data };
    case type.GET_SOCIETY_ROLES_FAILURE:
      return { ...state, loading: false, error: action?.message || 'Something went wrong.' };

    case type.GET_SOCIETY_ROLE_DETAILS:
      return { ...state, detailsLoading: true, error: null };
    case type.GET_SOCIETY_ROLE_DETAILS_SUCCESS:
      return { ...state, detailsLoading: false, roleDetails: action.payload };
    case type.GET_SOCIETY_ROLE_DETAILS_FAILURE:
      return { ...state, detailsLoading: false, error: action?.message || 'Something went wrong.' };

    case type.CREATE_SOCIETY_ROLE:
      return { ...state, createLoading: true, error: null };
    case type.CREATE_SOCIETY_ROLE_SUCCESS:
      return { ...state, createLoading: false };
    case type.CREATE_SOCIETY_ROLE_FAILURE:
      return { ...state, createLoading: false, error: action?.message || 'Something went wrong.' };

    case type.UPDATE_SOCIETY_ROLE:
      return { ...state, updateLoading: true, error: null };
    case type.UPDATE_SOCIETY_ROLE_SUCCESS:
      return { ...state, updateLoading: false };
    case type.UPDATE_SOCIETY_ROLE_FAILURE:
      return { ...state, updateLoading: false, error: action?.message || 'Something went wrong.' };

    case type.DELETE_SOCIETY_ROLE:
      return { ...state, deleteLoading: true, error: null };
    case type.DELETE_SOCIETY_ROLE_SUCCESS:
      return { ...state, deleteLoading: false };
    case type.DELETE_SOCIETY_ROLE_FAILURE:
      return { ...state, deleteLoading: false, error: action?.message || 'Something went wrong.' };

    case type.ASSIGN_ROLE_PERMISSIONS:
      return { ...state, assignLoading: true, error: null };
    case type.ASSIGN_ROLE_PERMISSIONS_SUCCESS:
      return { ...state, assignLoading: false, roleDetails: action.payload };
    case type.ASSIGN_ROLE_PERMISSIONS_FAILURE:
      return { ...state, assignLoading: false, error: action?.message || 'Something went wrong.' };

    case type.GET_PERMISSION_CATALOG:
      return { ...state, catalogLoading: true, error: null };
    case type.GET_PERMISSION_CATALOG_SUCCESS:
      return { ...state, catalogLoading: false, permissionCatalog: action.payload?.data };
    case type.GET_PERMISSION_CATALOG_FAILURE:
      return { ...state, catalogLoading: false, error: action?.message || 'Something went wrong.' };

    case type.GET_PERMISSION_CATALOG_GROUPED:
      return { ...state, catalogLoading: true, error: null };
    case type.GET_PERMISSION_CATALOG_GROUPED_SUCCESS:
      return { ...state, catalogLoading: false, permissionCatalogGrouped: action.payload?.data };
    case type.GET_PERMISSION_CATALOG_GROUPED_FAILURE:
      return { ...state, catalogLoading: false, error: action?.message || 'Something went wrong.' };

    case type.CLEAR_SOCIETY_ROLE_DETAILS:
      return { ...state, roleDetails: null };

    default:
      return state;
  }
}
